/**
 * Fuel level values
 */
export enum FuelLevelEnum {
	EMPTY = 'empty',
	ONE_EIGHTH = 'one_eighth',
	TWO_EIGHTHS = 'two_eighths',
	THREE_EIGHTHS = 'three_eighths',
	HALF = 'half',
	FIVE_EIGHTHS = 'five_eighths',
	SIX_EIGHTHS = 'six_eighths',
	SEVEN_EIGHTHS = 'seven_eighths',
	FULL = 'full',
	UNKNOWN = 'unknown',
}
